module.exports = ".alert {\n  background-color: red;\n  height: 5vh;\n  width: 100%; }\n"